import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Container,
  Card,
  Form,
  Button,
  Table,
  Row,
  Col,
} from "react-bootstrap";
import { fetchIndustries, deleteIndustry } from "../../services/industries";
import { _swal } from "../../utils/helper";
function IndustriesList() {
  const [industriesData, setIndustriesData] = useState({});
  const searchSchema = {
    name: null,
  };
  const [IndustrySearchValues, setIndustrySearchValues] =
    useState(searchSchema);
  const _fetchIndustries = async (queryParams = {}) => {
    await fetchIndustries(queryParams)
      .then((response) => {
        const { data } = response;
        setIndustriesData(data.data.industries);
      })
      .catch((err) => {
        console.log(err.response.data);
      });
  };
  const _deleteIndustry = async (id) => {
    const _confirm = window.confirm("Are you sure to delete?");
    if (_confirm) {
      await deleteIndustry(id)
        .then((response) => {
          const { data } = response;
          _swal(response.data.status, response.data.message);
          _fetchIndustries();
        })
        .catch((err) => {
          _swal(err.response.data.status, err.response.data.message);
          console.log(err.response.data);
        });
    }
  };
  const resetSearch = () => {
    _fetchIndustries({
      page: 1,
      per_page: 100,
      sort_column: "id",
      sort_order: "DESC",
    });
  };
  const filterIndustry = (
    page = null,
    sort_column = null,
    sort_order = null
  ) => {
    const filteredKeys = {};
    Object.entries(IndustrySearchValues).filter((v) => {
      if (v[1] !== null) {
        filteredKeys[v[0]] = v[1];
      }
    });
    _fetchIndustries({
      ...filteredKeys,
      page: page ? page : 1,
      per_page: 100,
      sort_column: sort_column ? sort_column : "id",
      sort_order: sort_order ? sort_order : "DESC",
    });
  };
  useEffect(() => {
    _fetchIndustries({
      page: 1,
      per_page: 100,
      sort_column: "id",
      sort_order: "DESC",
    });
  }, []);
  return (
    <Container className="my-2">
      <Card>
        <Card.Header as="h5">
          Industries{" "}
          <Button
            variant="primary"
            as={Link}
            to={"/admin/industries/create"}
            size="sm"
          >
            New
          </Button>
        </Card.Header>
        <Card.Body>
          <Form>
            <Row>
              <Col md="4">
                <Form.Group className="mb-3">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    placeholder="Industry Name"
                    value={
                      IndustrySearchValues.name !== null
                        ? IndustrySearchValues.name
                        : ""
                    }
                    onChange={(e) =>
                      setIndustrySearchValues({
                        ...IndustrySearchValues,
                        name: e.target.value,
                      })
                    }
                  />
                </Form.Group>
              </Col>
            </Row>

            <Button
              onClick={() => filterIndustry()}
              variant="primary"
              className="mr-2"
            >
              Filter
            </Button>
            <Button
              onClick={(e) => {
                setIndustrySearchValues({ ...searchSchema });
                resetSearch();
              }}
              variant="default"
            >
              Reset
            </Button>
          </Form>
        </Card.Body>
      </Card>
      <Table bordered width={"100%"} className="mt-2">
        <thead>
          <tr>
            <th width="25%">Industry Name</th>
            <th width="65%">Description</th>
            <th width="10%">Action</th>
          </tr>
        </thead>
        <tbody>
          {industriesData.length ? (
            industriesData.map((e) => {
              return (
                <tr>
                  <td>{e.name}</td>
                  <td>{e.description}</td>
                  <td>
                    <Button
                      variant="default"
                      as={Link}
                      to={"/admin/Industries/" + e.id + "/edit"}
                      size="sm"
                    >
                      Edit
                    </Button>
                    <Button
                      variant="warning"
                      size="sm"
                      onClick={() => _deleteIndustry(e.id)}
                    >
                      Delete
                    </Button>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={"3"}>Industries not found</td>
            </tr>
          )}
        </tbody>
      </Table>
    </Container>
  );
}

export default IndustriesList;
